import { Grid } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import { Booking, BookingStatus } from "src/business/booking";
import { StatCard } from "src/design";
import {
  iconBgInfo,
  iconColorInfo,
  iconBgSuccess,
  iconColorSuccess,
  iconBgPurple,
  iconColorPurple,
  colorDealBg,
  colorDealAccent,
} from "src/design/tokens";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

interface Props {
  bookings: Booking[];
}

export const BookingStatsRow = ({ bookings }: Props) => {
  const { t } = useTranslation();
  const today = dayjs().startOf("day");

  const todaysBookings = bookings.filter((b) =>
    dayjs(b.bookingDate).isSame(today, "day")
  );
  const todaysGuests = todaysBookings.reduce((sum, b) => sum + b.numberOfSeats, 0);
  const pendingCount = bookings.filter(
    (b) => b.bookingStatus === BookingStatus.PENDING
  ).length;
  const upcomingCount = bookings.filter((b) =>
    dayjs(b.bookingDate).isAfter(today, "day")
  ).length;
  const todaysNoShows = todaysBookings.filter(
    (b) => b.bookingStatus === BookingStatus.NO_SHOW
  ).length;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={2.4}>
        <StatCard
          label={t("bookings.stats.todaysBookings")}
          value={todaysBookings.length}
          icon={<CalendarTodayOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgInfo}
          iconColor={iconColorInfo}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <StatCard
          label={t("bookings.stats.todaysGuests")}
          value={todaysGuests}
          icon={<PeopleOutlineIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgSuccess}
          iconColor={iconColorSuccess}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <StatCard
          label={t("bookings.stats.pending")}
          value={pendingCount}
          icon={<AccessTimeIcon sx={{ fontSize: 18 }} />}
          iconBg={colorDealBg}
          iconColor={colorDealAccent}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <StatCard
          label={t("bookings.stats.upcoming")}
          value={upcomingCount}
          icon={<EventNoteOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgPurple}
          iconColor={iconColorPurple}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <StatCard
          label={t("bookings.stats.todaysNoShows")}
          value={todaysNoShows}
          icon={<PersonOffOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgPurple}
          iconColor={iconColorPurple}
        />
      </Grid>
    </Grid>
  );
};
